export const FOULING_NEW_EVENT_BUTTON_ANCHOR_ID = "fouling-new-event-button-anchor"
export const FOULING_NEW_EVENT_BUTTON_ANCHOR_SELECTOR = `#${FOULING_NEW_EVENT_BUTTON_ANCHOR_ID}`
